module.exports = __webpack_public_path__ + "static/media/_saba-island.0506f2bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_saba-island.svg
// module id = 2347
// module chunks = 7